module.exports = __webpack_public_path__ + "media/header_aktivni.1962f640.mp4";